export default function LoadingBox() {
    return (
        <div className="flex flex-col min-h-[600px] items-center justify-center p-8">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-600" />
            <p className="text-sm mt-5">One moment please...</p>
        </div>
    )
}